const awardsPressFunctions = () => {
    if ( $('.awards-press__filter-outer').length ) {
        ScrollTrigger.create({
            trigger: '.awards-press__filter-outer',
            start: () => {
                const headerHeight = $('.c-header__logo-row').outerHeight();
                return 'top top+=' + headerHeight;
            },
            endTrigger: '.awards-press',
            end: 'bottom bottom',
            pin: true,
            pinSpacing: false
        });
    }

    $(document).on('click', '.js-awards-press-filter:not(.active)', function(e) {
        const contentContainer = $('.js-awards-press-items-container');
        const section = $(this).data('section');

        $('.awards-press__filter-item').removeClass('active');
        $(this).addClass('active');

        // Set min height for the content
        const minHeight = contentContainer.outerHeight();
        contentContainer.css('min-height', minHeight+'px');

        let tl = gsap.timeline();
        tl.to(contentContainer, { autoAlpha: 0, duration: 0.4 });
        tl.to(contentContainer, { 
            autoAlpha: 1, duration: 0.4, delay: 0.4,
            onStart: () => {
                $('.'+section).show();
                $('.c-ap-items').not('.'+section).hide();
            },
            onComplete: () => {
                contentContainer.removeAttr('style');
                ScrollTrigger.refresh();
            }
        });
    });

    $(document).on('click', '.js-load-more-ap-items', function(e) {
        e.preventDefault();

        const remainingItems = $(this).closest('.c-ap-items').find('.c-ap-items__remaining-item');

        remainingItems.show();
        $(this).parent().removeClass('show');

        ScrollTrigger.refresh();
    });
}